export default __webpack_public_path__ + "static/media/2563.da07773d.png";